import { useContext } from 'react';

import {
  CONTEXT_NAMES,
  useStoreWithValidation,
} from '@adsk/alloy-react-context';

import LocaleContext from '../context';
import type { LocaleStore } from '../store';

export default (): {
  locale: string | undefined;
  setLocale: ((locale: string) => void) | undefined;
} => {
  const contextValue = useContext(LocaleContext);

  const store = useStoreWithValidation<LocaleStore>(
    CONTEXT_NAMES.LocaleContext,
    {
      hook: 'useLocale',
      provider: 'LocaleProvider',
      shouldThrowError: false,
    },
  );

  if (!contextValue && !store) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }

  return {
    locale: contextValue?.locale ?? store?.locale,
    setLocale: contextValue?.setLocale ?? store?.setLocale,
  };
};
